import React, { useState } from 'react'
import { FaCopy, FaRegCopy } from 'react-icons/fa'

import { cn, copyToClipboard } from '../lib/helpers'
import styles from './copyButton.module.css'
import { base } from './typography.module.css'

const CONFIRMATION_ANIMATION_TIME = 2000

const CopyButton = ({ text }) => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const handleOnClick = async () => {
    const copied = await copyToClipboard(text)
    setShowConfirmation(copied)
    setTimeout(() => setShowConfirmation(false), CONFIRMATION_ANIMATION_TIME)
  }

  return (
    <button
      type='button'
      title='Copy this code'
      onClick={handleOnClick}
      className={cn(base, styles.button)}
    >
      {showConfirmation ? <FaCopy /> : <FaRegCopy />}
      <span className={
        cn(styles.confirmation, showConfirmation ? styles.show : '')
      }
      >
        Copied to clipboard!
      </span>
    </button>
  )
}

export default CopyButton
